import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import NavHelper from '../../helper/NavHelper';

class Footer extends NavHelper {
    scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }
    render() {
        const stickyHeader = this.state.stickyHeader ? ' d-block' : '';
        return (
            <Fragment>
                {/* Footer */}
                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 wow fadeInLeft"> <Link to="/"> <img src={process.env.PUBLIC_URL + "/assets/images/logo-1.png"} alt="logo" /> </Link>
                                <p className="mt-3 text-white"> Phasellus blandit massa enim. Nullam id varius nunc. Lorem ipsum dolor sit
                                    amet, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius nunc. </p>
                                <ul className="social-link">
                                    <li><Link to="#" className="twitter"><i className="fab fa-twitter" /></Link></li>
                                    <li><Link to="#" className="linkedin"><i className="fab fa-linkedin-in" /></Link></li>
                                    <li><Link to="#" className="instagram"><i className="fab fa-instagram" /></Link></li>
                                    <li><Link to="#" className="facebook"><i className="fab fa-facebook-f" /></Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6  offset-md-1 offset-lg-1 wow fadeInDown">
                                <h4 className="footer-title">Useful Links</h4>
                                <ul className="footer-link">
                                    <li><Link to="/" className="text-white"><i className="fas fa-chevron-right" /> Home</Link></li>
                                    <li><Link to="/about" className="text-white"><i className="fas fa-chevron-right" /> About Us</Link></li>
                                    <li><Link to="/blog-grid" className="text-white"><i className="fas fa-chevron-right" /> Blog</Link></li>
                                    <li><Link to="/contact" className="text-white"><i className="fas fa-chevron-right" /> Contact</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 wow fadeInRight">
                                <h4 className="footer-title">Other Links</h4>
                                <ul className="footer-link">
                                    <li><Link to="/faqs" className="text-white"><i className="fas fa-chevron-right" /> FAQ's</Link></li>
                                    <li><Link to="/gallery" className="text-white"><i className="fas fa-chevron-right" /> Gallery</Link></li>
                                    <li><Link to="/error-page" className="text-white"><i className="fas fa-chevron-right" /> Error 404</Link></li>
                                    <li><Link to="/shop-grid" className="text-white"><i className="fas fa-chevron-right" /> Shop</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 wow fadeInRight">
                                <h4 className="footer-title">Newslatter</h4>
                                <p className="text-custom-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                <div className="form-group">
                                    <input type="email" name="#" className="form-control form-control-custom" placeholder="Email I'd" required />
                                </div>
                                <div className="form-group">
                                    <button type="submit" className="btn-first btn-submits">Subscribe</button>
                                </div>
                            </div>
                        </div>
                        <p className="copyright">© 2022 <Link to="#" className="text-custom-blue">Website.</Link> All Right Reserved.</p>
                    </div>
                </footer>
                {/* Back to top */}
                <div id="back-top" className={"back-top" + stickyHeader}>
                    <Link to="#" onClick={(e) => this.scrollToTop()}><i className="flaticon-arrows" /></Link>
                </div>
                {/* Footer */}
            </Fragment>
        );
    }
}

export default Footer;